export default __webpack_public_path__ + "static/media/facebook logo i 0.2e8b91ad.png";